import { Flex, Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import copanLogo from '../../assets/logo_copan.webp';
import LoggedUser from '../loggedUser/loggedUser';
import './layout.css';


const { Header, Content } = Layout;

const AppLayout = () => (
	<Layout style={{ minHeight: '100vh' }}>
		<Header className="header">
        <Flex  justify='space-between' align='center' horizontal style={{padding:"0 12px"}}> 
			<img className="header-logo-box-img" src={copanLogo} alt="logo copan" style={{
				width: "100px",
				height: "52px",
			}} />
			<LoggedUser />
            </Flex>
		</Header>
		<Layout>
			<Content
				className="site-layout-background"
				style={{
					padding: 12,
					margin: 0,
					minHeight: 280,
				}}
			>
				<Outlet />
			</Content>
		</Layout>
	</Layout>
);

export default AppLayout;